export const isLocalEnv = () => {
  try {
    // @ts-ignore env
    return __HOST_LOCAL__ || __HOST_TEST__;
  } catch {
    return false;
  }
};

export const isBuildIn = () => {
  try {
    // @ts-ignore env
    return __BUILD_IN__;
  } catch {
    return false;
  }
};
export const getStripePublicKey = () => {
  // @ts-ignore env
  return import.meta?.env?.VITE_CDN_HOST;
};

// export const buildLanguageIsZh = () => {
//   try {
//     // @ts-ignore env
//     return __LOCALE__ === 'zh' || __LOCALE__ === 'tc';
//   } catch {
//     return false;
//   }
// };

export const isPrivate = () => {
  try {
    // @ts-ignore env
    return __PRIVATE__;
  } catch {
    return false;
  }
};

export const getCdnHost = () => {
  try {
    // @ts-ignore env
    if (import.meta?.env?.VITE_CDN_HOST) {
      // @ts-ignore env
      return import.meta?.env?.VITE_CDN_HOST;
    }
    // @ts-ignore env
    return isBuildIn() ? 'https://cdn2.buildin.ai/' : 'https://cdn2.flowus.cn/';
  } catch {
    return '';
  }
};

export const getProductName = () => {
  try {
    // @ts-ignore env
    return import.meta?.env?.VITE_PRODUCT_NAME || (isBuildIn() ? 'Buildin.AI' : 'FlowUs');
  } catch {
    return 'FlowUs';
  }
};

export const getProductAiName = () => {
  try {
    // @ts-ignore env
    return import.meta?.env?.VITE_PRODUCT_AI_NAME || (isBuildIn() ? 'Buildin.AI' : 'FlowUs AI');
  } catch {
    return 'FlowUs AI';
  }
};

export const getProductAllName = () => {
  try {
    // @ts-ignore env
    return import.meta?.env?.VITE_PRODUCT_ALL_NAME || (isBuildIn() ? 'Buildin.AI' : 'FlowUs');
  } catch {
    return 'FlowUs';
  }
};

export const commonInjector = {
  isBuildIn: isBuildIn(),
  // @ts-ignore env
  cdnHost: getCdnHost(),
  // languageIsZh: buildLanguageIsZh(),
  productName: getProductName(),
  productAiName: getProductAiName(),
  productAllName: getProductAllName(),
};

export const commonInit = (params: Partial<typeof commonInjector>) => {
  Object.assign(commonInjector, params);
};
